<template>
  <div id="app">
    <div class="app" id="app1">
      <div class="login">
        <!-- <header id="title" class="login-head animated lightSpeedIn">智慧用电综合管理中心</header> -->
        <div class="login-con">
          <div class="login-div-head masked">
            <!-- <p class="login-div-head-p1">逸慧家智慧用电与消防安全隐患预警系统</p> -->
            <!-- <p class="login-div-head-p1">中国燃气安全智能监测控制平台</p> -->
            <p class="login-div-head-p1">{{ titleCh }}</p>
            <!-- <p class="login-div-head-p2">Smart electricity equipment supervision</p> -->
            <!-- <p class="login-div-head-p2">CHINA INTELLIGENT GAS SAFETY MONITORING PLATFORM</p> -->
            <p class="login-div-head-p2">{{ titleEn }}</p>
          </div>
          <div class="login-card">
            <p class="login-card-title">{{ $t('login.login.443414-0') }}</p>
            <div class="login-card-input-view">
              <div class="login-card-input-view-img">
                <img src="../../assets/login/yonghuming.png" alt="">
              </div>
              <div class="login-card-input">
                <input type="text" v-model="LoginCode" value="" :placeholder="$t('login.login.443414-1')" />
              </div>
            </div>
            <div class="login-card-input-view">
              <div class="login-card-input-view-img">
                <img src="../../assets/login/mima.png" alt="">
              </div>
              <div class="login-card-input">
                <input @keyup.enter="Login" @focus="changeInputType" :type="inputType" v-model="LoginPassword" value=""
                  :placeholder="$t('login.login.443414-2')" />
              </div>
            </div>
            <div class="login-card-input-checkbox">
              <Checkbox v-model="remember">{{ $t('login.login.443414-3') }}</Checkbox>
              <span style="float: right; color: #0ba1f8; cursor: pointer;" @click="showModal = true">{{ $t('login.login.443414-4') }}</span>
            </div>
            <div class="login-card-input-but">
              <Button @click="Login()" :loading="loading">{{ $t('login.login.443414-0') }}</Button>
            </div>
          </div>
        </div>
        <Modal v-model="showModal" :title="$t('login.login.443414-4')" :footer-hide="true">
          <Form label-position="right" :label-width="140" ref="formValidate" :model="formPassWord" :rules="ruleValidate">
            <FormItem :label="$t('login.login.443414-5')" prop="LoginCode" class="f12" style="margin-right: 100px;">
              <Input v-model="formPassWord.LoginCode" :placeholder="$t('login.login.443414-6')" autocomplete="new-password"></Input>
            </FormItem>
            <FormItem :label="$t('login.login.443414-7')" prop="OldPassword" class="f12" style="margin-right: 100px;">
              <Input type="password" password v-model="formPassWord.OldPassword" :placeholder="$t('login.login.443414-6')"
                autocomplete="new-password"></Input>
            </FormItem>
            <FormItem :label="$t('login.login.443414-8')" prop="NewPassword" class="f12" style="margin-right: 100px;">
              <Input type="password" password v-model="formPassWord.NewPassword" :placeholder="$t('login.login.443414-6')"
                autocomplete="new-password"></Input>
            </FormItem>
            <FormItem :label="$t('login.login.443414-9')" prop="ConfirmPassword" class="f12" style="margin-right: 100px;">
              <Input type="password" password v-model="formPassWord.ConfirmPassword" :placeholder="$t('login.login.443414-6')"
                autocomplete="new-password"></Input>
            </FormItem>
            <slot name="footer">
              <div style="display: flex; justify-content: flex-end; margin-top: 40px;">
                <Button style="margin-right: 8px;" @click="cancel">{{ $t('login.login.443414-10') }}</Button>
                <Button type="primary" @click="submit">{{ $t('login.login.443414-11') }}</Button>
              </div>
            </slot>
          </Form>
        </Modal>
        <div class="QR-code-div">
          <div class="QR-code-inco">
            <img src="../../assets/login/QR_code_inco.png" alt="">
          </div>
          <div class="QR-code-text-view">
            <p class="QR-code-text1">{{ $t('login.login.443414-12') }}</p>
            <p class="QR-code-text2">DownloadApp</p>
          </div>
        </div>
        <div class="QR-code-view">
          <div class="QR-code-view-item">
            <div class="QR-code-view-item-img">
              <img src="../../assets/login/app_qr_code.png" alt="">
            </div>
            <div class="QR-code-view-item-p">{{ $t('login.login.443414-13') }}</div>
          </div>
          <div class="QR-code-view-item">
            <div class="QR-code-view-item-img">
              <img src="../../assets/login/wx_qr_code.jpg" alt="">
            </div>
            <div class="QR-code-view-item-p">{{ $t('login.login.443414-14') }}</div>
          </div>
        </div>

        <div class="AnimationImg" style="display: block;">
          <!--左侧两幢建筑数据-->
          <div class="Img1"></div>
          <div class="Img2"></div>
          <div class="Img3"></div>
          <div class="Img4"></div>
          <div class="ImgUp"></div>
          <!--中间圆形-->
          <div class="ImgBox1"></div>
          <div class="ImgBox2"></div>
          <div class="ImgCircle"></div>
          <div class="ImgCircle2"></div>
          <div class="ImgCircle3"></div>
          <div class="ImgCircle4"></div>
          <!--柱状图-->
          <div class="histogram">
            <div class="green"></div>
            <div class="blue"></div>
            <div class="orange"></div>
          </div>
          <!--饼图-->
          <div class="pie"></div>
          <div class="pieR"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/request.js'
import Cookies from 'js-cookie'
import THREE from "../../api/three.js";

var SEPARATION = 100,
  AMOUNTX = 60,
  AMOUNTY = 40;
var container;
var camera, scene, renderer;
var particles, particle, count = 0;
var mouseX = 0,
  mouseY = 0;
var windowHalfX = window.innerWidth / 2;
var windowHalfY = window.innerHeight / 2;
var threeState = true;

export default {
  data() {
    return {
      LoginCode: '',
      LoginPassword: '',
      loading: false,
      inputType: 'text',
      remember: false,
      returnCitySN: {},
      titleCh: '',
      titleEn: '',
      showModal: false,
      formPassWord: {
        Id: 0,
        LoginCode: '',
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: ''
      },
      ruleValidate: {
        LoginCode: [{ required: true, message: this.$t('login.login.443414-6'), trigger: 'change' }],
        OldPassword: [{ required: true, message: this.$t('login.login.443414-6'), trigger: 'change' }],
        NewPassword: [{ required: true, message: this.$t('login.login.443414-6'), trigger: 'change' }],
        ConfirmPassword: [{ required: true, message: this.$t('login.login.443414-6'), trigger: 'change' }],
      },
    }
  },

  mounted() {
    let _this = this;

    if (window.location.host == 'home.hxpwr.com') {
      _this.titleCh = _this.$t('login.login.443414-15');
      _this.titleEn = "SAFE ELECTRICITY AND GAS MANAGEMENT PLATFORM";
    } else if (window.location.host == 'yxyp.nb.hxpwr.com') {
      _this.titleCh = _this.$t('login.login.443414-15');
      _this.titleEn = "One County One Product Safety Management Platform";
    } else if (window.location.host == 'xed.hxpwr.com') {
      _this.titleCh = _this.$t('login.login.443414-16');
      _this.titleEn = "Xinde gas electric intelligent safety monitoring control platform";
    } else {
      _this.titleCh = _this.$t('login.login.443414-17');
      _this.titleEn = "Electricity safety management platform";
    }

    // let data = Cookies.get('Remember') ? JSON.parse(Cookies.get('Remember')) : '';
    console.log(JSON.parse(localStorage.getItem('Remember')));
    let data = localStorage.getItem('Remember') ? JSON.parse(localStorage.getItem('Remember')) : '';
    _this.LoginCode = data.LoginCode;
    _this.LoginPassword = data.LoginPassword;
    _this.remember = data.remember;
    if (_this.LoginPassword) {
      _this.inputType = 'password'
    }

    if (_this.$store.getters.getUserState) {
      _this.$Message['error']({
        background: true,
        content: this.$t('login.login.443414-18')
      });
    }

    // console.log(window.returnCitySN);
    _this.returnCitySN = window.returnCitySN;
    _this.$store.dispatch("setUserState", false);

    // 登录特效
    _this.threes();
  },
  methods: {
    submit() {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.changePassword();
        } else {
          this.$Message.error(this.$t('login.login.443414-19'));
        }
      })
    },

    changePassword() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/User/UserUpdatePassword',
        data: this.formPassWord,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      }).then((res) => {
        if (res.Success) {
          this.$Message['success']({
            background: true,
            content: res.Message
          });
          this.cancel();
        } else {
          this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      })
    },

    cancel() {
      this.$refs['formValidate'].resetFields();
      this.formPassWord = {
        Id: 0,
        LoginCode: '',
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: ''
      }
      this.showModal = false;
    },

    threes() {
      let _this = this;

      _this.init(); //初始化

      if (threeState) {
        _this.animate(); //动画效果
        threeState = false
      }
    },

    init() {

      /*
      position: absolute;
          bottom: 0;
          z-index: -1;
          background-color: #1D81EF;*/

      container = document.createElement('div'); //创建容器
      container.style.position = "absolute";
      container.style.zIndex = "1";
      container.style.bottom = "-250px";

      document.getElementById("app1").appendChild(container); //将容器添加到页面上
      // document.body.appendChild(container); //将容器添加到页面上
      camera = new THREE.THREE.PerspectiveCamera(120, window.innerWidth / window.innerHeight, 1, 1500); //创建透视相机设置相机角度大小等
      camera.position.set(0, 450, 2000); //设置相机位置

      scene = new THREE.THREE.Scene(); //创建场景
      particles = new Array();

      var PI2 = Math.PI * 2;
      //设置粒子的大小，颜色位置等
      var material = new THREE.THREE.ParticleCanvasMaterial({
        color: 0x0f96ff,
        vertexColors: true,
        size: 4,
        program: function (context) {
          context.beginPath();
          context.arc(0, 0, 0.01, 0, PI2, true); //画一个圆形。此处可修改大小。
          context.fill();
        }
      });
      //设置长条粒子的大小颜色长度等
      var materialY = new THREE.THREE.ParticleCanvasMaterial({
        color: 0xffffff,
        vertexColors: true,
        size: 1,
        program: function (context) {

          context.beginPath();
          //绘制渐变色的矩形
          var lGrd = context.createLinearGradient(-0.008, 0.25, 0.016, -0.25);
          lGrd.addColorStop(0, '#16eff7');
          lGrd.addColorStop(1, '#0090ff');
          context.fillStyle = lGrd;
          context.fillRect(-0.008, 0.25, 0.016, -0.25); //注意此处的坐标大小
          //绘制底部和顶部圆圈
          context.fillStyle = "#0090ff";
          context.arc(0, 0, 0.008, 0, PI2, true); //绘制底部圆圈
          context.fillStyle = "#16eff7";
          context.arc(0, 0.25, 0.008, 0, PI2, true); //绘制顶部圆圈
          context.fill();
          context.closePath();
          //绘制顶部渐变色光圈
          var rGrd = context.createRadialGradient(0, 0.25, 0, 0, 0.25, 0.025);
          rGrd.addColorStop(0, 'transparent');
          rGrd.addColorStop(1, '#16eff7');
          context.fillStyle = rGrd;
          context.arc(0, 0.25, 0.025, 0, PI2, true); //绘制一个圆圈
          context.fill();

        }
      });

      //循环判断创建随机数选择创建粒子或者粒子条
      var i = 0;
      for (var ix = 0; ix < AMOUNTX; ix++) {
        for (var iy = 0; iy < AMOUNTY; iy++) {
          var num = Math.random() - 0.1;
          if (num > 0) {
            particle = particles[i++] = new THREE.THREE.Particle(material);
          } else {
            particle = particles[i++] = new THREE.THREE.Particle(materialY);
          }
          //particle = particles[ i ++ ] = new THREE.Particle( material );
          particle.position.x = ix * SEPARATION - ((AMOUNTX * SEPARATION) / 2);
          particle.position.z = iy * SEPARATION - ((AMOUNTY * SEPARATION) / 2);
          scene.add(particle);
        }
      }

      renderer = new THREE.THREE.CanvasRenderer();
      renderer.setSize(window.innerWidth, window.innerHeight);
      container.appendChild(renderer.domElement);
      //document.addEventListener( 'mousemove', onDocumentMouseMove, false );
      //document.addEventListener( 'touchstart', onDocumentTouchStart, false );
      //document.addEventListener( 'touchmove', onDocumentTouchMove, false );
      window.addEventListener('resize', this.onWindowResize(), false);
    },

    //浏览器大小改变时重新渲染
    onWindowResize() {
      windowHalfX = window.innerWidth / 2;
      windowHalfY = window.innerHeight / 2;
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    },

    animate() {
      requestAnimationFrame(this.animate);
      this.render();
    },

    //将相机和场景渲染到页面上
    render() {
      var i = 0;
      //更新粒子的位置和大小
      for (var ix = 0; ix < AMOUNTX; ix++) {
        for (var iy = 0; iy < AMOUNTY; iy++) {
          particle = particles[i++];
          //更新粒子位置
          particle.position.y = (Math.sin((ix + count) * 0.3) * 50) + (Math.sin((iy + count) * 0.5) * 50);
          //更新粒子大小
          particle.scale.x = particle.scale.y = particle.scale.z = ((Math.sin((ix + count) * 0.3) + 1) * 4 + (Math.sin(
            (iy + count) * 0.5) + 1) * 4) * 50; //正常情况下再放大100倍*1200
        }
      }

      renderer.render(scene, camera);
      count += 0.1;
    },


    changeInputType() {
      this.inputType = 'password'
    },

    Login() {
      let _this = this;

      let data = {
        LoginCode: _this.LoginCode,
        LoginPassword: _this.LoginPassword,
        LoginAddress: _this.returnCitySN && _this.returnCitySN.cname,
        Ip: _this.returnCitySN && _this.returnCitySN.cip
      }

      if (!data.LoginCode) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('login.login.443414-20')
        });
        return;
      }

      if (!data.LoginPassword) {
        _this.$Message['error']({
          background: true,
          content: _this.$t('login.login.443414-21')
        });
        return;
      }
      _this.loading = true;

      api({
        //这里是你自己的请求方式、url和data参数
        method: 'post',
        url: 'api/User/UserLogin',
        data: data,
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      }).then(function (res) {
        _this.loading = false;
        if (res.Success) {

          // 是否记住密码
          if (_this.remember) {
            localStorage.setItem('Remember', JSON.stringify({
              remember: true,
              ...data
            }));
          } else {
            localStorage.setItem('Remember', JSON.stringify({
              LoginCode: _this.LoginCode,
              LoginPassword: '',
              remember: false
            }));
          }

          // 储存后台返回位置
          Cookies.set('cityName', res.Data.AddressName);

          // 保存token
          Cookies.set('Token', res.Data.token_type + ' ' + res.Data.access_token);
          // 保存集团部门编号s
          Cookies.set('AdminData', {
            GroupCode: res.Data.GroupCode,
            CompanyCode: res.Data.CompanyCode,
            DepartmentCode: res.Data.DepartmentCode,
            IsAdmin: res.Data.IsAdmin,
            TittleName: res.Data.TittleName,
            TittleNameEN: res.Data.TittleNameEN,
            ImageUrl: res.Data.ImageUrl,
            Uid: res.Data.Id
          });

          //内嵌的地图页面需要用户信息获取设备信息
          let SmartVillage = {
            GroupCode: res.Data.GroupCode,
            CompanyCode: res.Data.CompanyCode,
            DepartmentCode: res.Data.DepartmentCode,
            IsAdmin: res.Data.IsAdmin,
            Token: res.Data.token_type + ' ' + res.Data.access_token
          }
          localStorage.setItem('SmartVillage', JSON.stringify(SmartVillage))

          // 保存登录名
          Cookies.set('UserLogin', res.Data.UserInfo.UserLogin);

          _this.$store.dispatch("setCodeValue",
            `${res.Data.GroupCode}${res.Data.CompanyCode}${res.Data.DepartmentCode}`);
          _this.$router.push({
            name: 'home',
            params: {
              fromLogin: true
            }
          })
        } else {
          _this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });

      // _this.$router.push({name: 'home'})
    },
  }
}
</script>

<style scoped="scoped">
@import url("./login.css");
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue